export default __webpack_public_path__ + "static/hp-brand-deck-13-1f9c6f53c32f06e5449d511bd860c774.png";